<script lang="ts">
  import PictureTag from '../PictureTag.svelte';

  export let content;
</script>

<div class="row-flex">
  <div class="heading col-flex-md-12">
    <h5>{content?.imageTitle}</h5>
  </div>
  <div class="image-section">
    {#each content?.images as image}
      <PictureTag image={image?.image} mobileImage={image?.mobileImage} alt={image?.imageAltText} />
    {/each}
  </div>
</div>

<style lang="scss">
  @import '../../styles/colors.new.scss';
  .row-flex {
    gap: 90px;
    justify-content: center;
    @include desktop-max-width {
      gap: 40px;
    }
    .heading {
      justify-content: center;
      flex-direction: column;

      h5 {
        font-weight: 700;
        font-size: 40px;
        line-height: 52px;
        text-align: center;

        @include desktop-max-width {
          font-size: 14px;
        }
      }
    }
    .image-section {
      align-items: center;
      justify-content: center;
      display: flex;
      flex-direction: column;
      gap: 90px;
      @include desktop-max-width {
        gap: 40px;
        padding: 0 15px;
      }
    }
  }
</style>
